import React, { useEffect, useState } from 'react'
import DataTable from '../../../component/data_table/DataTable'
import AddButton from '../../../component/buttons/AddButton';
import { Link, useNavigate } from 'react-router-dom';
import { FilePenLine, Trash2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { departmentListTodo } from '../../../redux/slices/master/department/DepartmentList';
import Loader from '../../../component/loader/Loader';
import { deleteDepartmentTodo } from '../../../redux/slices/master/department/DeleteDepartment';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';

export default function DepartmentList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const departmentList = useSelector(state => state?.departmentList?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(departmentListTodo({ navigate })).then((res) => list_res(res?.payload))
    }, [bool])

    const list_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const editUser = (data) => {
        navigate('/update-department', { state: data })
    }

    const deleteUser = (data) => {
        Swal.fire({
            title: "Department Delete",
            text: 'Are you sure want to delete',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Confirm'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteDepartmentTodo(data)).then((res) => del_res(res))
            }
        })
    }

    const del_res = (res) => {
        if (res?.payload?.status == 204) {
            setBool(!bool)
            Swal.fire({
                title: 'Department',
                text: res?.data?.massage,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
        } else {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }



    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'DEPARTMENT',
            field: 'name',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },

        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params =>
                params?.data?.status === 'Active'
                    ? <span className='badge text-bg-success'>Active</span>
                    : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span
                        data-tooltip-id='edit'
                        data-tooltip-content="Department Update"
                        data-tooltip-place="bottom"
                        onClick={() => editUser(params?.data)}
                    >
                        <FilePenLine className='text-success' size={20} />
                    </span>
                    {/* <span className='ms-2'
                        data-tooltip-id='delete'
                        data-tooltip-content="Department Delete"
                        data-tooltip-place="bottom"
                        onClick={() => deleteUser(params?.data?._id)}
                    >
                        <Trash2 className='text-danger' size={20} />
                    </span> */}
                    <Tooltip id='edit' className='bg-success tooltip_msg' />
                    <Tooltip id='delete' className='bg-danger tooltip_msg' />
                </div>
            ),
            autoHeight: true,
        }
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>Department List</h5>
                            <Link to='/add-department'>   <AddButton label={"Add DEPARTMENT"} /> </Link>
                        </div>
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={departmentList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}
